import Referrals from "../pages/Referrals";

export default function PortalReferralsPanel() {
  return (
    <div className="min-h-0 flex-1 bg-[hsl(var(--ds-bg))] text-[hsl(var(--ds-fg))]">
      <Referrals />
    </div>
  );
}
